import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { Table } from 'legacy/lut/library/list'
import * as React from 'react'
import { useEffect, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import { columns } from './configs'
import { IPartnerAuditProps } from './models'
import { partnerAuditTranslation } from './translation'

import styles from './PartnerAudit.module.scss'

export const PartnerAudit = ({ onClose, partnerId, isVisible }: IPartnerAuditProps) => {
  const crudSource = useMemo(() => {
    const crud = CrudStore.get(CrudStoreItem.PartnerLegalExtendLog)

    crud.setSort({ field: 'Created', dir: 'desc' })

    return crud
  }, [])

  const renderContent = React.useCallback(() => {
    crudSource.removeQueries(true)

    return (
      <>
        <div className={styles.auditHeader}>
          <div className={styles.auditHeaderTitle}>
            <Translation text={partnerAuditTranslation.title} span />
          </div>
          <Button variant="contained" color="primary" onClick={onClose}>
            <Translation text={partnerAuditTranslation.buttons.apply} span />
          </Button>
        </div>
        <Table
          source={crudSource}
          header={true}
          pagination={true}
          flexWidth={'10/15'}
          columns={columns}
          hasTranslate
        />
      </>
    )
  }, [crudSource, onClose])

  useEffect(() => {
    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerID',
          operator: Operator.EQUAL,
          value: partnerId,
        },
      ],
    }
    crudSource.setFilter(filter)
  }, [crudSource, partnerId])

  return <ModalDialog show={isVisible} size="lg" onClose={onClose} content={renderContent} />
}
